import { FunctionComponent } from 'react';
import { InfoFill } from 'ui/icons/status/InfoFill';
import { colors } from 'ui/theme/colors';
import { StyledCaption } from '../Styled';
import { RefreshingCaptionProps, GoalStatus } from '../../types';
import { TEST_IDS, REFRESH_CAPTION } from '../../constants';

export const RefreshingCaption: FunctionComponent<
  React.PropsWithChildren<RefreshingCaptionProps>
> = ({ goalStatus }) => {
  if (goalStatus === GoalStatus.REFRESHING) {
    return (
      <StyledCaption data-test={TEST_IDS.RefreshingStateCaption}>
        <div>
          <InfoFill color={colors.grey60} />
        </div>
        <div>{REFRESH_CAPTION}</div>
      </StyledCaption>
    );
  } else {
    return null;
  }
};
export default RefreshingCaption;
